// import { encryptTest } from "../../../../commons/utils/crypto";
function initEnv () {
    const subdomain = window.location.hostname.split('.')[0];
    const regularDomain = [
        'localhost',
        'localhost:3040',
    ];
    if (!regularDomain.includes(subdomain) && isNaN(Number(subdomain))) {
        this.subdomain = subdomain;
    }
    // encryptTest();
}

export default initEnv;
